import React from "react";
import "./Team_group_page.css";
import {
  Team_photo1,
  Team_photo2,
  Team_photo3,
  Team_photo4,
  Team_photo5,
  Team_photo6,
  Team_photo7,
  Team_photo8,
  Team_photo9,
  Team_photo10,
  Team_photo11,
  Team_photo12,
} from "../../assets";

const Team_group_page = () => {
  const teamPhotos = [
    Team_photo1,
    Team_photo2,
    Team_photo3,
    Team_photo4,
    Team_photo5,
    Team_photo6,
    Team_photo7,
    Team_photo8,
    Team_photo9,
    Team_photo10,
    Team_photo11,
    Team_photo12,
  ];

  return (
    <div className="text_team">
      <h2 className="mb-5">Team photos</h2>

      <div className="grid-container">
        {teamPhotos.map((photo, index) => (
          <div className="photo-item" key={index}>
            <img src={photo} alt={`ELEMENT${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team_group_page;
